import ax from '../api/AxiosConfig';
import { formatDate, formatDateOnly } from '../../utils/CommonUtils';
import { apiUrls } from '../api/ApiConstants';
import moment from 'moment';

export const getAssetNotes = async (timeRange: any, urlData: any) => {
  try {
    const payload = {
      "AssetId": urlData.AssetId,
      "ProductType": "Soofie",
      "DateFilterStartDate": timeRange.StartDate,
      "DateFilterEndDate": timeRange.EndTime,
      "CustomerId": urlData.CustomerId,
    }
    const response = await ax.post('/Emission/GetAssetNotes', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getSiteDetails = async (urlData: any) => {
  try {
    const siteId = urlData.AssetId;
    const url = `/sites/${siteId}/DetailsWithEquipment`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getSliderDataPoints = async (timeRange: any, urlData: any) => {
  try {
    /*Notes : This APi will call, on load of the page, to Get all alarms details.
    for a specific time range(24hr - 365 days) for time slider - 96 data points
   */
    const startDate = moment(timeRange.StartDate, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const endDate = moment(timeRange.EndTime, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const siteId = urlData.AssetId;
    const url = `/sites/${siteId}/emission/emission-summary?startTime=${startDate}&endTime=${endDate}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getDeviceMaintenanceInfo = async (urlData: any, timeZone: string) => {
  try {
    const payload = {
      "AssetId": urlData.AssetId,
      "Customerid": urlData.CustomerId,
      "TimeZone": timeZone
    }
    const response = await ax.post('/Emission/GetDeviceMaintenanceInfo', payload)
    return response.data;
  } catch (error) {
    console.error('Error in Axios request:', error);
    throw error;
  }
};

export const getAssetLatestStatus = async (urlData: any, timeZone: string) => {
  try {
    /*Notes : This API is used to bind Soofie Data where there is no alert and time interval is > 24hrs.
             There is some specific logic for “Last CH4 Emission” need to check User Story for the logic/requirement.
             If CH4 Emission “LastCh4” value is Null, Then we need to show lastCH4Error value.
   */
    const siteId = urlData.AssetId;
    const url = `/sites/${siteId}/emission/latest-emission-summary?timeZone=${timeZone}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getAllAlertsForEachSlide = async (
  urlData: any,
  currObj: any,
  alertTimeRange: any,

) => {
  try {
    /*Notes : This APi will call, on load of the page, to Get all alarms details.
    for a specific time range(24hr - 365 days) for time slider - 96 data points
   */
    const siteId = urlData.AssetId;
    const customerId = urlData.CustomerId;
    const startTime = currObj.dateTime;
    const interval = alertTimeRange.interval;
    const queryParams = `startTime=${encodeURIComponent(startTime)}&interval=${interval}&customerId=${customerId}`;
    const url = `/sites/${siteId}/emission/emission-summary-details?${queryParams}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getMethane = async (timeRange: any, interval: number, urlData: any, timeZone: string) => {
  try {
    const startDate = timeRange.StartDate;
    const endDate = timeRange.EndTime;
    const params = new URLSearchParams({
      StartTime: startDate,
      EndTime: endDate,
      TimeZone: timeZone,
      UOM: "Metric",
      Duration: interval.toString(),
    });

    const url = `/sites/${urlData.AssetId}/analysis/methanetable?${params.toString()}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};


export const GetSoofieTimeseriesData = async (
  timeRange: any,
  urlData: any,
  timeZone: string
) => {
  try {
    const siteId = urlData.AssetId;
    const startTime = timeRange.StartDate;
    const endTime = timeRange.EndTime;
    const duration = 1;
    const unit = "Metric";

    const query = `StartTime=${encodeURIComponent(startTime)}&EndTime=${encodeURIComponent(endTime)}&Duration=${duration}&TimeZone=${encodeURIComponent(timeZone)}&UnitOfMeasurement=${unit}`;

    const url = `/sites/${siteId}/analysis/timeseries?${query}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    console.error("Error in Axios request:", error);
    throw error;
  }
};



/* Operation overview dashboard API start */
export const getOpSiteDetails = async ({ startDate, endDate }: { startDate: Date, endDate: Date }) => {
  try {
    const startDateString = formatDate(startDate)
    const endDateString = formatDate(endDate)
    const response = await ax.get("/emissions/overview", {
      params: {
        StartTime: startDateString,
        EndTime: endDateString,
      },
    });

    return response.data.data;
  } catch (error) {
    throw error;
  }
};

export const getEmissionAlerts = async ({ startDate, endDate }: { startDate: Date, endDate: Date }) => {
  try {
    const startDateString = formatDate(startDate);
    const endDateString = formatDate(endDate);

    let queryParam = `StartTime=${startDateString}&EndTime=${endDateString}`;
    const response = await ax.get(`emissions/alerts?${queryParam}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAssetAlerts = async ({ startDate }: { startDate: Date }) => {
  try {

    const startDateString = formatDateOnly(startDate).slice(0, 10);

    let queryParam = startDateString;
    const response = await ax.get(`/assets/alerts/${queryParam}`);
    return response.data;

  } catch (error) {
    throw error;
  }
};

export const getAssetHierarchy = async () => {
  try {
    const response = await ax.get("/Customer/CustomersSites");
    return response.data.data;
  } catch (error) {
    throw error;
  }
};
export const getUserPreferences = async () => {
  try {
    const response = await ax.get("/User/GetUserSettings");
    return response.data;
  } catch (error) {
    throw error;
  }
};


/* Emission performance dashboard API */

export const getTotalEmissionsData = async ({ startTime, endTime, customerID = "", timeZone, siteIds = [], query = "", orderBy }: { startTime: Date, endTime: Date, customerID: string, timeZone: string, siteIds?: any, query?: any, orderBy: number }) => {
  try {
    const startDateString = moment(startTime, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const endDateString = moment(endTime, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const payload = {
      customerID: customerID,
      startTime: startDateString,
      endTime: endDateString,
      siteIds: siteIds,
      OrderBy: orderBy
    };
    const response = await ax.post('/emissions/GetTotalEmission', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getGlobalSummaryView = async ({ endTime, customerID = "", timeZone, siteIds = [] }: { endTime: Date, customerID: string, timeZone: string, siteIds?: any }) => {
  const endDateString = formatDate(endTime);
  try {
    const payloadForGlobalSummary = {
      siteIds: siteIds,
      customerID: customerID,
      endTime: endDateString,
      TimeZone: timeZone
    };

    const response = await ax.post('/emissions/GetGlobalSummaryView', payloadForGlobalSummary);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserDetails = async () => {
  try {
    const response = await ax.post("/Employee/GetUserDetails");
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getHeatMapData = async ({ siteId, siteName, customerId = "", customerName, region, startTime, endTime, units, comparison, threshold }: { siteId: string, siteName: string, customerId: string, customerName: string, region: string, startTime: Date, endTime: Date, units: string, comparison: string, threshold: string }) => {
  try {
    const payload = {
      SiteId: siteId,
      SiteName: siteName,
      CustomerId: customerId,
      CustomerName: customerName,
      StartTime: startTime,
      EndTime: endTime,
      Units: units,
      Comparison: comparison,
      Threshold: threshold
    };
    const response = await ax.post('/Emission/GetHeatMapData', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};


export const getProbableSource = async ({ startDate, endDate, customerId = "", timeZone, assetId = "" }: { startDate: Date, endDate: Date, customerId: string, timeZone: string, assetId?: string }) => {
  try {
    const startDateString = startDate;
    const endDateString = endDate;
    const payload = {
      AssetId: assetId,
      CustomerId: customerId,
      StartTime: startDateString,
      EndTime: endDateString,
      TimeZone: timeZone,
    };

    const response = await ax.post('/Emission/GetProbableSource', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteConfigurationHistory = async ({ startDate, endDate, customerId = "", timeZone, assetId = "" }: { startDate: Date, endDate: Date, customerId: string, timeZone: string, assetId?: string }) => {
  try {
    const startDateString = startDate;
    const endDateString = endDate;
    const payload = {
      AssetId: assetId,
      CustomerId: customerId,
      StartTime: startDateString,
      EndTime: endDateString,
      TimeZone: timeZone,
    };

    const response = await ax.post('/Emission/SiteConfigurationHistory', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWorkorderHistory = async ({ startDate, endDate, customerId = "", timeZone, assetId = "" }: { startDate: Date, endDate: Date, customerId: string, timeZone: string, assetId?: string }) => {
  try {
    const startDateString = startDate;
    const endDateString = endDate;
    const payload = {
      AssetId: assetId,
      CustomerId: customerId,
      StartTime: startDateString,
      EndTime: endDateString,
      TimeZone: timeZone,
    };

    const response = await ax.post('/Emission/WorkorderHistory', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getPeriodicSurveys = async ({ startDate, endDate, customerId = "", timeZone, assetId = "" }: { startDate: Date, endDate: Date, customerId: string, timeZone: string, assetId?: string }) => {
  try {
    const startDateString = startDate;
    const endDateString = endDate;
    const payload = {
      AssetId: assetId,
      CustomerId: customerId,
      StartTime: startDateString,
      EndTime: endDateString,
      TimeZone: timeZone,
    };

    const response = await ax.post('/Emission/PeriodicSurveys', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getWindRoseData = async ({ startDate, endDate, customerId = "", assetId = "" }: { startDate: Date, endDate: Date, customerId: string, assetId?: string }) => {
  try {
    const response = await ax.get(`/sites/${assetId}/history/windrose?StartTime=${startDate}&EndTime=${endDate}`);
    return response.data;

  } catch (error) {
    throw error;
  }
};

export const getConfigurationTable = async ({ customerId = "", assetId = "" }: { customerId: string, assetId?: string }) => {
  try {
    const url = `/sites/${assetId}/history/configurations`;
    const response = await ax.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteMaintenanceData = async ({ startDate, endDate, customerId = "", assetId = "" }: { startDate: Date, endDate: Date, customerId: string, assetId?: string }) => {
  try {

     const url = `/sites/${assetId}/history/maintenance?CustomerId=${customerId}&StartTime=${startDate}&EndTime=${endDate}`;

    const response = await ax.get(url);
    return response.data;

  } catch (error) {
    throw error;
  }
}

export const saveMaintenanceData = async ({ siteId, custId, date, userName, deviceName, activity }: { siteId: string, custId: string, date: string, userName: string, deviceName: string, activity: string }) => {
  try {
    const response = await ax.post('/sites/SiteMaintenanceHistory', {
      SiteId: siteId,
      CustomerId: custId,
      Date: date,
      UserName: userName,
      DeviceName: deviceName,
      Activity: activity
    }, {
      headers: {
        'Content-Type': 'application/json'
      }
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteHistoryUptimeReport = async ({ startTime, endTime, customerId = "", isPercent, siteId = "" }: { startTime: Date, endTime: Date, customerId: string, isPercent: Boolean, siteId?: string }) => {
  try {
    const params: any = {
      CustomerId: customerId,
      StartTime: startTime,
      EndTime: endTime,
      isPercent: isPercent
    };
    console.log("Fetching site history uptime report with params:", params);
    const response = await ax.get(`/sites/${siteId}/history/uptimereport`, { params });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetSoofieUptimeExport = async ({ StartTime, EndTime, CustomerId = "", SiteId = "" }: { StartTime: Date, EndTime: Date, CustomerId: any, SiteId?: string }) => {

  try {
    const payload: any = {
      CustomerId: CustomerId,
      SiteId: SiteId,
      StartTime: StartTime,
      EndTime: EndTime,
    };

    const response = await ax.get('/reports/SoofieUptimeExport', { params: payload });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetSoofieUptimeGlobal = async ({
  startTime,
  endTime,
  customerId = "",
  siteIds = [],
  isPercent
}: {
  startTime: Date;
  endTime: Date;
  customerId: any;
  siteIds?: any[];
  isPercent: Boolean;
}) => {
  try {
    const response = await ax.post(
      `/reports/SoofieUptimeGlobal`,
      {
        CustomerId: customerId,
        StartTime: startTime,
        EndTime: endTime,
        isPercent: isPercent,
        SiteIds: siteIds && siteIds.length > 0 ? siteIds : []
      }
    );

    return response.data.data;
  } catch (error) {
    throw error;
  }
};


export const GetGroundDataDetails = async ({ startTime, endTime, customerId = "", siteIds = [], deviceId }: { startTime: Date, endTime: Date, customerId: any, siteIds?: any, deviceId: any }) => {

  try {
    const url = `/reports/GroundDataDetails/${deviceId}`;
    const response = await ax.get(url, {
      params: {
        startDate: startTime,
        endDate: endTime,
      },
    });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const GetAsset = async ({ customerId = "" }: { customerId: any }) => {

  try {
    const url = `/EmissionCustomer/GetAssets/${customerId}`;
    const response = await ax.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getToken = async ({ UserName, Password }: { UserName: any, Password: any }) => {

  try {
    const payload: any = {
      UserName: UserName,
      Password: Password
    };

    const response = await ax.post('/Emission/Token', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const getAuthToken = async ({ username, password, }: { username: string; password: string; }) => {
  try {
    const payload = {
      username,
      password,
      grantType: 1,
    };

    const options = {
      headers: { "Content-Type": "application/json" },
    };

    const response = await ax.post(apiUrls.token, payload, options);
    const { accessToken, refreshToken, expiresIn } = response.data.data; // ✅ Correct way

    return { accessToken, refreshToken, expiresIn };

  } catch (error) {
    throw error;
  }
};

export const getRefreshToken = async ({ refreshtoken, accessToken }: { refreshtoken: any, accessToken: any }) => {

  try {
    const payload: any = {
      refreshtoken: refreshtoken,
      accessToken: accessToken,
      grantType: 2,
    };

    const response = await ax.post('/Auth/authenticate', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSiteReprocess = async ({ customerIds, siteIds, startDate, endDate, }: {
  customerIds: any[]; siteIds: any[]; startDate: string; endDate: string;
}) => {
  try {
    const payload: any = {
      customerIds: customerIds,
      siteIds: siteIds,
      startDate: startDate,
      endDate: endDate,
    };

    const response = await ax.post('/Emission/GetSiteReprocess', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRegenerateBilling = async ({ customerIds, month }: { customerIds: any[]; month: string; }) => {
  try {
    const payload: any = {
      customerIds: customerIds,
      month: month,
    };
    const response = await ax.post('/reports/ReGenerateSoofieBill', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getUserList = async () => {
  try {
    const response = await ax.get('/EmissionCustomer/GetUsers');
    return response.data;
  } catch (error) {
    throw error;
  }
}


export const getAnomalySoofieTimeseriesData = async ({
  timeRange,
  urlData
}: {
  timeRange: any;
  urlData: any;
}) => {
  try {
    const siteId = urlData.AssetId;
    const startDate = moment(timeRange.StartDate, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const endDate = moment(timeRange.EndTime, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");

    const url = `/sites/${siteId}/analysis/AIAnomaly?StartTime=${startDate}&EndTime=${endDate}`;

    const response = await ax.get(url);
    return response.data.data;
  } catch (error) {
    throw error;
  }
};


export const getAIAnomalySoofie = async ({ StartDate, EndDate, AssetId }: {
  StartDate: string; EndDate: string; AssetId: string;
}) => {
  try {
    // Format dates for the API endpoint
    const startDate = moment(StartDate, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const endDate = moment(EndDate, "MM-DD-YYYY HH:mm").format("MM-DD-YYYY");
    const siteId = AssetId; 
    const url = `/sites/${siteId}/analysis/AIAnomalyEvents?StartTime=${startDate}&EndTime=${endDate}`;

    const response = await ax.get(url);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getSites = async (customerId: string) => {
  try {
    const payload = {
      customerId: customerId
    };

    const response = await ax.get('/Emission/GetSites', { params: payload });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getEquipmentAndDevices = async (siteId: string) => {
  try {
    const payload = {
      siteId: siteId
    };

    const response = await ax.get('/Emission/GetEquipments', { params: payload });
    return response.data;
  } catch (error) {
    throw error;
  }
}

export const getAccessLevels = async (customerId: string) => {
  try {
    const response = await ax.get(`/EmissionCustomer/GetAccesslevel/${customerId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getRoles = async (customerId: string) => {
  try {
    const response = await ax.get(`/EmissionCustomer/GetRoles/${customerId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const postNewUserDetails = async ({ customerId, firstName, lastName, email, contactNumber, active, jobTitle, assetVisibility, accessLevel, userType, provisioningAdmin, }: {
  customerId: string;
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  active: boolean;
  jobTitle: string | null;
  assetVisibility: string | null;
  accessLevel: string;
  userType: string;
  provisioningAdmin: boolean;
}) => {
  try {
    const payload = {
      CustomerID: customerId,
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      ContactNumber: contactNumber,
      Active: active,
      JobTitle: jobTitle,
      AssetVisibility: assetVisibility,
      AccessLevel: accessLevel,
      UserType: userType,
      ProvisioningAdmin: provisioningAdmin,
    };

    const response = await ax.post('/EmissionCustomer/User', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getAssetVisibility = async (customerId: string) => {
  try {
    const response = await ax.get(`/EmissionCustomer/GetAssetvisibility/${customerId}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const editUserDetails = async ({
  firstName,
  lastName,
  email,
  contactNumber,
  active,
  jobTitle,
  assetVisibility,
  accessLevel,
  isAuraCameraUser,
}: {
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  active: boolean;
  jobTitle: string | null;
  assetVisibility: string | null;
  accessLevel: string;
  isAuraCameraUser: boolean;
}) => {
  try {
    const payload = {
      FirstName: firstName,
      LastName: lastName,
      Email: email,
      ContactNumber: contactNumber,
      Active: active,
      JobTitle: jobTitle,
      AssetVisibility: assetVisibility,
      AccessLevel: accessLevel,
      IsAuraCameraUser: isAuraCameraUser,
    };

    const response = await ax.put('/EmissionCustomer/User', payload);

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteUser = async ({
  id,
  userId,
  name,
}: {
  id: string;
  userId: string;
  name: string;
}) => {
  try {
    const payload = {
      id: id,
      userid: userId,
      name: name,
    };

    const response = await ax.post('/EmissionCustomer/DeleteUser', payload);
    return response.data;
  } catch (error) {
    throw error;
  }
};
export const alarmSummary = async ({
  customerId,
  productType,
  pageNo,
  pageSize
}: {
  customerId: string;
  productType: string;
  pageNo: number;
  pageSize: number;
}) => {
  try {
    const response = await ax.get(
      `/Emission/GetAlarmSummary?CustomerID=${customerId}&ProductType=${productType}&PageNo=${pageNo}&PageSize=${pageSize}`
    );

    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getOneHourAverage = async ({
  siteId,
  startTime,
  endTime
}: {
  siteId: string;
  startTime: string;
  endTime: string;
}) => {
  try {
    const response = await ax.get(`/sites/${siteId}/analysis/OneHourAverage?StartTime=${startTime}&EndTime=${endTime}`);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getKMLDownloadData = async (params: {
  siteId: string;
  emissionDevices: string[];
  emission: number;
  siteName: string;
  windDirection: number;
  windSpeed: number;
  windDirectionDeviation: number;
  siteLength: number;
}) => {
  const {
    siteId,
    emissionDevices,
    emission,
    siteName,
    windDirection,
    windSpeed,
    windDirectionDeviation,
    siteLength,
  } = params;

  const queryParams = new URLSearchParams();
  emissionDevices.forEach((device, index) => {
    queryParams.append(`EmissionDevices[${index}]`, device);
  });

  queryParams.append("Emission", emission.toString());
  queryParams.append("SiteName", siteName);
  queryParams.append("WindDirection", windDirection.toString());
  queryParams.append("WindSpeed", windSpeed.toString());
  queryParams.append("WindDirectionDeviation", windDirectionDeviation.toString());
  queryParams.append("SiteLength", siteLength.toString());

  const response = await ax.get(`v1/sites/${siteId}/analysis/DownloadKML?${queryParams.toString()}`);

  return response.data;
};